import React, { useContext } from "react";
import arrowDownIcon from "../../../assets/images/arrow-down.svg";
import { DialogContext } from "../../../context/DialogContext";
import { ToolNavigationItem } from "../../../models/navigation/ToolNavigationItem";

interface Props extends ToolNavigationItem {
  fontClass: string;
}

export const MarketToolLink = (props: Props) => {
  const { dispatch } = useContext(DialogContext);

  return (
    <button
      type="button"
      className={`${props.fontClass} cursor-pointer inline-flex justify-between items-center text-inherit font-bold no-underline focus:shadow-outline focus:outline-none`}
      title={props.title}
      onClick={() => dispatch({ type: "marketSelector.open" })}
    >
      <span className="mr-1">{props.title}</span>
      <svg width={11} height={11} className="stroke-current">
        <use xlinkHref={arrowDownIcon.url} />
      </svg>
    </button>
  );
};
